export default {"src":"/_next/static/media/poa.169fe119.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};